export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false,
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            }
        ],
        formActions: [],
        rowActions: [],
        headerFields: [
            {
                name: "id",
                label: "id",
                filter: {
                    type: "simple",
                },
                visibility: false,

            },
            {
                name: "doctorId",
                label: "doctorId",
                filter: {
                    type: "simple",
                },
                visibility: false,

            },
            {
                name: "siteName",
                label: "Ellátóhely",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "doctorName",
                label: "Orvos",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "treatmentTypeName",
                label: "Kezelés",
                filter: {
                    type: "simple",
                },
                visibility: true,

            },
            {
                name: "treatmentDate",
                label: "Dátum",
                filter: {
                    type: "simple",
                },
                visibility: true,
                slot_name: 'appointment_format'
            },
            {
                name: "doctorPayment",
                label: "Jutalék",
                filter: {
                    type: "simple",
                },
                slot_name: 'commission_format',
                visibility: true,

            },
            {
                name: "patientName",
                label: "Páciens",
                filter: {
                    type: "simple",
                },
                visibility: true,

            },
            {
                name: "siteId",
                label: "siteId",
                filter: {
                    type: "simple",
                },
                visibility: false,

            },
            {
                name: "appointmentStatusId",
                label: "appointmentStatusId",
                filter: {
                    type: "simple",
                },
                visibility: false,

            },
            {
                name: "appointmentStatus",
                label: "Előjegyzés állapot",
                filter: {
                    type: "simple",
                },
                visibility: true,

            },
            {
                name: "treatmentStatus",
                label: "Kezelés állapot",
                filter: {
                    type: "simple",
                },
                visibility: true,

            }
        ]
    }
}
